import { Box, Tab, Tabs, Typography } from "@mui/material";
import SearchInput from "../../../../shared/SearchInput/SearchInput";

const HeaderSection = ({ tabIndex, handleTabChange, search, setSearch }) => {
  const titles = ["Звiльненi оператори", "Заблоковані оператори"];

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      mb={3}
    >
      {/* Заголовок */}
      <Typography variant="h6" fontWeight={600}>
        {titles[tabIndex]}
      </Typography>

      {/* Центр — таби */}
      <Box flexGrow={1} display="flex" justifyContent="center">
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            minHeight: "auto",
            "& .MuiTab-root": {
              minHeight: "36px",
              minWidth: "100px",
              textTransform: "none",
              borderRadius: "8px",
              px: 2,
              py: 1,
              mx: 0.5,
              fontWeight: 500,
            },
            "& .Mui-selected": {
              backgroundColor: "primary.text",
              color: "#fff",
            },
          }}
        >
          <Tab label="Звiльненi" disableRipple />
          <Tab label="Заблоковані" disableRipple />
        </Tabs>
      </Box>

      {/* Пошук */}
      <SearchInput
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Пошук оператора..."
      />
    </Box>
  );
};

export default HeaderSection;
